let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i0bKN")).then(() => parcelRequire('2wtDB'));